import React, { useState } from 'react';
import './HyperliquidSetup.css';
import ApiService from '../services/api';

const HyperliquidSetup = ({ onComplete, onSkip }) => {
  const [formData, setFormData] = useState({
    apiKey: '',
    secretKey: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [showKeys, setShowKeys] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.apiKey || !formData.secretKey) {
      setError('Veuillez remplir tous les champs');
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      const result = await ApiService.setHyperliquidKeys(
        formData.apiKey.trim(),
        formData.secretKey.trim()
      );

      if (result.success) {
        onComplete();
      }
    } catch (error) {
      setError(error.message || 'Erreur lors de la configuration');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="hyperliquid-setup">
      <div className="setup-container">
        <div className="setup-header">
          <h2>🔑 Configuration Hyperliquid</h2>
          <p>Configurez vos clés API Hyperliquid pour commencer le trading automatisé</p>
        </div>

        <div className="setup-info">
          <div className="info-card">
            <h3>📋 Comment obtenir vos clés API ?</h3>
            <ol>
              <li>Connectez-vous à <a href="https://app.hyperliquid.xyz" target="_blank" rel="noopener noreferrer">Hyperliquid</a></li>
              <li>Allez dans <strong>Settings → API</strong></li>
              <li>Créez une nouvelle clé API</li>
              <li>Copiez la <strong>API Key</strong> et le <strong>Secret</strong></li>
              <li>Collez-les ci-dessous</li>
            </ol>
          </div>

          <div className="security-notice">
            <h4>🔒 Sécurité</h4>
            <ul>
              <li>✅ Vos clés sont chiffrées avant stockage</li>
              <li>✅ Elles ne sont jamais transmises en clair</li>
              <li>✅ Seul votre bot y a accès</li>
              <li>⚠️ Ne partagez jamais vos clés API</li>
            </ul>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="setup-form">
          {error && (
            <div className="error-message">
              ⚠️ {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="apiKey">
              🔑 Clé API Hyperliquid
            </label>
            <input
              type={showKeys ? 'text' : 'password'}
              id="apiKey"
              name="apiKey"
              value={formData.apiKey}
              onChange={handleInputChange}
              placeholder="Entrez votre clé API Hyperliquid"
              disabled={isSubmitting}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="secretKey">
              🔐 Clé Secrète
            </label>
            <input
              type={showKeys ? 'text' : 'password'}
              id="secretKey"
              name="secretKey"
              value={formData.secretKey}
              onChange={handleInputChange}
              placeholder="Entrez votre clé secrète"
              disabled={isSubmitting}
              required
            />
          </div>

          <div className="form-options">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={showKeys}
                onChange={(e) => setShowKeys(e.target.checked)}
              />
              <span className="checkmark"></span>
              Afficher les clés
            </label>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="skip-button"
              onClick={onSkip}
              disabled={isSubmitting}
            >
              ⏭️ Passer pour l'instant
            </button>
            
            <button
              type="submit"
              className="submit-button"
              disabled={isSubmitting || !formData.apiKey || !formData.secretKey}
            >
              {isSubmitting ? (
                <>
                  <div className="spinner"></div>
                  Configuration...
                </>
              ) : (
                <>
                  🚀 Configurer et Démarrer
                </>
              )}
            </button>
          </div>
        </form>

        <div className="setup-footer">
          <div className="help-links">
            <a 
              href="https://hyperliquid.gitbook.io/hyperliquid-docs/for-developers/api" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              📚 Documentation API
            </a>
            <a 
              href="https://app.hyperliquid.xyz/trade" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              🌐 Hyperliquid App
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HyperliquidSetup;
